import React from 'react';
import MemberMiniMenu from '../../members/menus/MemberMiniMenu';
import InvoiceContent from './InvoiceContent';

const MemberInvoicesPage = () => {

    return (
        <MemberMiniMenu>
            <InvoiceContent invoiceType='purchase' title="Member Invoices" />
        </MemberMiniMenu>
    );
};

export default MemberInvoicesPage;